<div class="help-tooltip active">
  <p>
    {{textService.currentText.refundTooltipMessage}} {{refundDate}}
  </p>
</div>
